import { render, staticRenderFns } from "./inclusion.vue?vue&type=template&id=7dc20146&scoped=true&"
import script from "./inclusion.vue?vue&type=script&lang=js&"
export * from "./inclusion.vue?vue&type=script&lang=js&"
import style0 from "./inclusion.vue?vue&type=style&index=0&id=7dc20146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc20146",
  null
  
)

export default component.exports